export type TEmailBuilderHistoryHotkeyAction = "undo" | "redo";

export interface IEmailBuilderHistoryHotkeyEvent {
  key: string;
  ctrlKey: boolean;
  metaKey: boolean;
  shiftKey: boolean;
  altKey?: boolean;
  target: EventTarget | null;
}

export function isEmailBuilderFormFieldTarget(target: EventTarget | null): boolean {
  if (target === null || typeof target !== "object") {
    return false;
  }

  const element = target as {
    tagName?: unknown;
  };

  if (typeof element.tagName !== "string") {
    return false;
  }

  const tagName = element.tagName.toUpperCase();
  return tagName === "INPUT" || tagName === "TEXTAREA" || tagName === "SELECT";
}

export function isEmailBuilderTextEditableTarget(target: EventTarget | null): boolean {
  if (isEmailBuilderFormFieldTarget(target)) {
    return true;
  }

  if (target === null || typeof target !== "object") {
    return false;
  }

  const element = target as {
    isContentEditable?: unknown;
  };

  return element.isContentEditable === true;
}

export function resolveEmailBuilderHistoryHotkey(
  event: IEmailBuilderHistoryHotkeyEvent,
): TEmailBuilderHistoryHotkeyAction | null {
  if (isEmailBuilderFormFieldTarget(event.target) || isEmailBuilderTextEditableTarget(event.target)) {
    return null;
  }

  const key = event.key.toLowerCase();
  const modifierPressed = event.metaKey || event.ctrlKey;

  if (modifierPressed && key === "z") {
    return event.shiftKey ? "redo" : "undo";
  }

  if (event.ctrlKey && !event.metaKey && key === "y" && !event.shiftKey) {
    return "redo";
  }

  return null;
}

export function emailBuilderIsMacPlatform(userAgent: string): boolean {
  return userAgent.includes("Mac");
}

export function emailBuilderHistoryHotkeyShortcutLabels(isMac: boolean): {
  undo: string;
  redo: string;
} {
  if (isMac) {
    return {
      undo: "⌘Z",
      redo: "⌘⇧Z",
    };
  }

  return {
    undo: "Ctrl+Z",
    redo: "Ctrl+Y",
  };
}
